<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-4 col-lg-4">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>                         
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstplanosdetreino"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                                                      
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstplanosdetreino.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-10 col-lg-10">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa" class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center">TREINOS</div>
                                    <div class="card-body">
                                        <div class="row">          
                                            <div class="col-sm-12 col-md-10 col-lg-10">
                                                <label for="eddescricaotreino">*Nome do treino:</label>
                                                <input type="text" v-model="vdescricaotreino" class="form-control form-control-sm" id="eddescricaotreino" maxlength="50" style="text-transform: uppercase;">
                                            </div>                                            
                                                                                                                
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <button type="button" id="btincplano" class="btn btn-info btn-sm"
                                                    style="width:100%; margin-top: 22px;" @click.prevent="mtdincluirtreino()"><i class="fa fa-plus-circle"></i>
                                                    Incluir
                                                </button>
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistaclasses" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-light">
                                                            <tr>
                                                                <th width="180" style="text-align: center;">Ações:</th>
                                                                <th width="80">Id:</th>
                                                                <th>Descrição:</th>                                      
                                                            </tr>
                                                        </thead>
                                                        <tbody id="lsttreinosplanos">
                                                            <template v-for="(plano, index) in lsttreinos" >
                                                                <tr v-bind:key="index">
                                                                    <td width="180" class="center" style="text-align: center;">
                                                                        <a class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"
                                                                            v-bind:disabled="ativadesativa"
                                                                            @click.prevent="mtdalterartreino(index, plano.descricao)" title="Alterar">
                                                                            <i class="fa fa-edit"></i>
                                                                        </a>                                                                         
                                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                            v-bind:disabled="ativadesativa"
                                                                            @click.prevent="mtdexcluirtreino(index)" title="Excluir">
                                                                            <i class="fa fa-trash"></i>
                                                                        </a>  
                                                                        <a class="btn btn-secondary btn-sm btn-opcrud ajt-btn" href="#"
                                                                            v-bind:disabled="ativadesativa"
                                                                            @click.prevent="mtdveritenstreino(index)" title="Incluir exercicios">
                                                                            <i class="fa fa-object-group"></i>
                                                                        </a>                                                                      
                                                                    </td>                                                                                                                           
                                                                    <td width="80">{{ mtdformatarzeros(plano.id, 2) }}</td>
                                                                    <td>{{ plano.descricao }}</td>                      
                                                                </tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>                                                                                                                        
                                        </div>
                                    </div>
                                </div>                                                 
                            </div>                                                        
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>                            
            </div>
        </div>
        <!-- Modal para edição da descrição do plano de treino -->
        <div class="modal fade" id="mdledicaobotao">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">Edição do botão do PDV</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <label for="ededicaobotao">*Descrição:</label>
                                <input type="text" v-model="descbotaoedicao" 
                                    class="form-control form-control-sm" id="ededicaobotao" maxlength="50"
                                    style="text-transform: uppercase;" data-bv-group=".group">
                            </div>                                                                               
                        </div>
                 
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" @click.prevent="mtdconfirmaedicaobotao()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>         


        <!-- Modal para vizualizar/ incluir os exercicios do plano -->
        <div class="modal fade" id="mdedicaoitenstreino">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">EXERCICIOS DO TREINO</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <!-- <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="edidprodutoedicao">*Exercicio:</label>
                                <div class="input-group" style="z-index: 1;">
                                    <input type="text" class="form-control form-control-sm" id="edidprodutoedicao" v-model="vcoddigedicao" maxlength="20" v-on:blur="mtdlocalizarexercicio(vcoddigedicao)" v-on:keyup.13="mtdlocalizarexercicio(vcoddigedicao)" style="text-transform: uppercase;">
                                    <div class="input-group-append">
                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarexercicio()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                    </div>
                                </div>
                            </div>   
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <label for="eddescricaoprodutoedicao">Descrição do exercicio:</label>
                                <input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoexercicioedicao" maxlength="100" style="font-weight: bold; text-transform: uppercase;" disabled>
                            </div>   -->
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <span class="lblselect2">Exercicio:</span>
                                <select id="cbexercicioincluir" data-placeholder="Selecione um exercicio" v-model="videxercicioedicao"  data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2" >
                                <label for="cbcombinado">Combinado:</label>
                                <select name="cbcombinado" class="form-control form-control-sm" id="cbcombinado" v-model="vcombinado">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div style="padding-top: 20px;" class="col-sm-2 col-md-2 col-lg-2">
                                <button  type="button" class="btn btn-sm btn-block btn-primary" @click.prevent="mtdincluirprodutobotao()"> Incluir</button>
                            </div>                                                                          
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table id="tblistaclasses" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-light">
                                            <tr>
                                                <th width="180" style="text-align: center;">Ações:</th>
                                                <th width="80">Id:</th>
                                                <th>Descrição:</th>
                                                <th>Combinados:</th>
                                                                                            
                                            </tr>
                                        </thead>
                                        <tbody id="lstitensbotoes">
                                            <template v-for="(item, index) in lstitenstreinoalt" >
                                                <tr v-bind:key="index">
                                                    <td width="80" class="center" style="text-align: center;">
                                                                                                                      
                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                            v-bind:disabled="ativadesativa"
                                                            @click.prevent="mtdexcluiritembotao(index)" title="Excluir">
                                                            <i class="fa fa-trash"></i>
                                                        </a> 
                                                        
                                                        <a class="btn btn-secondary btn-sm btn-opcrud ajt-btn" href="#"
                                                            v-bind:disabled="ativadesativa"
                                                            @click.prevent="mtdadicionarcombinados(index)" title="Combinar exercicios">
                                                            <i class="fa fa-object-group"></i>
                                                        </a>  
                                                                                                                       
                                                    </td>                                                                                                                           
                                                    <td width="80">{{ mtdformatarzeros(item.idexercicio, 2) }}</td>
                                                    <td v-if="parseInt(item.combinado) === 0" >{{ item.descricao }}</td>
                                                    <td v-else >{{ item.desccombo }}</td>        
                                                    <td>
                                                        <div class="dv-lst-precos-produto">
                                                            <ul class="list-group">
                                                                <li v-for="(combinado, indexf) in item.exercicioscombinados" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" v-bind:class="indexf%2 == 0 ? 'bkg-smoke' : ''" style="padding: 2px;">
                                                                    <span class="lbltabelalstpro">{{combinado.descricao}}</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>                      
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>  
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" @click.prevent="confirmaitenstreino()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>        


        
        <!-- Modal para Consultar exercicios -->
        <!-- <div class="modal fade" id="mdselecionarexercicio">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                  
                    <div class="modal-header">
                        <h4 class="modal-title">Consulta exercicios</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltroexercicio">Filtrar:</label>
                                <select name="cbopfiltroexercicio" class="form-control form-control-sm" id="cbopfiltroexercicio" v-model="pfiltroexercicio" @change="mtdlimpar_listagemexercicios()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudoexercicio" @keyup="mtdlimpar_listagemexercicios()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistrosexercicio" @change="mtdlimpar_listagemexercicios()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisaexercicios()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstexercicios"
                                        :columns="columnsexer"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                              
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                                       
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdselecionarexercicio(item.row)"><i class="fa fa-hand-o-up"></i></button>                                   
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstexercicios.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                    </div>
                    <div class="modal-footer">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atualexer"
                                        :page-count="pqtd_paginasexer"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>   -->
        
          <!-- Modal para Consultar exercicios -->
          <!-- <div class="modal fade" id="mdcombinarexercicios">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">
                   
                    <div class="modal-header">
                        <h4 class="modal-title">Combinar exercicios</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-10">
                                <span class="lblselect2">Exercicio:</span>
								<select id="cbexerciciocombinar" data-placeholder="Selecione um exercicio" v-model="videxerciciocombinar"  data-allow-clear="true" style="width:100%;">
								</select>
                            </div>
                            <div class="col-2">
                                <button type="button" class="btn btn-sm btn-block btn-primary" @click.prevent="mtdincluirexerciciocombinado()"><i class="fa fa-check"></i> Incluir</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="table-responsive">
                                    <table id="tblistaexerciciosvincular" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-light">
                                            <tr>
                                                <th width="180" style="text-align: center;">Ações:</th>
                                                <th width="80">Id:</th>
                                                <th>Descrição:</th>                                              
                                            </tr>
                                        </thead>
                                        <tbody id="lstitensbotoes">
                                            <template v-for="(item, index) in lstexercicioscombinados" >
                                                <tr v-bind:key="index">
                                                    <td width="80" class="center" style="text-align: center;">                                                         
                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                            v-bind:disabled="ativadesativa"
                                                            @click.prevent="mtdexcluircombinado(index)" title="Excluir">
                                                            <i class="fa fa-trash"></i>
                                                        </a>                                                                                
                                                    </td>                                                                                                                           
                                                    <td width="80">{{ mtdformatarzeros(item.idexercicio, 2) }}</td>
                                                    <td>{{ item.descricao }}</td>                          
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">   
                         <button type="button" class="btn btn-sm  btn-primary" @click.prevent="mtdconfirmaselecaocombinado()"><i class="fa fa-check"></i> Confirmar seleção</button>
                         <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>  -->
        <div class="modal fade" id="mdcombinarexercicios">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">Combinar exercicios com {{ vlabelexercicios }}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-6">
                                <label for="edconteudopesq">Nome do combo:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="vdesccombo">
                            </div>
                            <div class="col-4">
                                <span class="lblselect2">Exercicio:</span>
								<select id="cbexerciciocombinar" data-placeholder="Selecione um exercicio" v-model="videxerciciocombinar"  data-allow-clear="true" style="width:100%;">
								</select>
                            </div>
                            <div class="col-2">
                                <button type="button" class="btn btn-sm btn-block btn-primary" @click.prevent="mtdincluirexerciciocombinado()"><i class="fa fa-check"></i> Incluir</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="table-responsive">
                                    <table id="tblistaexerciciosvincular" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-light">
                                            <tr>
                                                <th width="180" style="text-align: center;">Ações:</th>
                                                <th width="80">Id:</th>
                                                <th>Descrição:</th>                                              
                                            </tr>
                                        </thead>
                                        <tbody id="lstitensbotoes">
                                            <template v-for="(item, index) in lstexercicioscombinados" >
                                                <tr v-bind:key="index">
                                                    <td width="80" class="center" style="text-align: center;">                                                         
                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                            v-bind:disabled="ativadesativa"
                                                            @click.prevent="mtdexcluircombinado(index)" title="Excluir">
                                                            <i class="fa fa-trash"></i>
                                                        </a>                                                                                
                                                    </td>                                                                                                                           
                                                    <td width="80">{{ mtdformatarzeros(item.idexercicio, 2) }}</td>
                                                    <td>{{ item.descricao }}</td>                          
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">   
                         <button type="button" class="btn btn-sm  btn-primary" @click.prevent="mtdconfirmaselecaocombinado()"><i class="fa fa-check"></i> Confirmar seleção</button>
                         <button type="button" class="btn btn-sm btn-secondary" @click.prevent="mtdcancelacombinado()"  data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>  


    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadgruposplanoscontas',
        components:{
            VueBootstrap4Table,
            'consultaprodutos'  : ConsultarProdutos,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                //variaveis da consulta de produtos
				vshowprtabela			: false,//oculta a visualização do preço do produto na listagem
				vidtabela				: 1,//informo somente pq o componente exige
                tipopropesquisa         : '',
                lstplanosdetreino  : [],
                lsttreinos       : [],
                pfiltro      : 1,
                pconteudo    : '',
                ptipo        : 2,
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                

                //variáveis dos planos
                vordem                 : 0,
                vdescricaotreino        : '',
                lstitenstreinoalt      : [],

                //variavel da inclusao de itens noss botoes 
                vcoddigedicao          : '',
                vdescricaoexercicioedicao: '',
                videxercicioedicao       : null,  
                indicealteracaoitens   : 0,
                lstexercicioscombinados :[],
                indicealteracaoexcombinado: 0,
                videxerciciocombinar      : null,
                vcombinado                : 0,
                vindicegeralcombo         : 0,
                vlabelexercicios          : '', 
                vdesccombo                : '',                 


        

                //variável para habilitação dos campos
                ativadesativa       : true,

                //variável da importação
                vtpimportacao           : 0,
                vlimpardados            : false,
                vadicionaraocadastro    : false,
                arqselecionado          : null,
                vimportarcodigos        : false, 
               


                //variaveis consulta de exercicios
                pfiltroexercicio      : 1,
                pconteudoexercicio    : '',
                ptipoexer        : 2,
                pqtdregistrosexercicio: 10,
                pqtd_paginasexer : 1,
                pagina_atualexer : 1,
                pqtd_total_registrosexer: 0,
                lstexercicios : [],
                combinado     : false,

                //edicao do plano
                indicebotaoedicao : 0,
                descbotaoedicao   : '',
                idintegracaoedicao: '',    
                vdtemissao : util.DataAtual(),              

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'PLANOS DE TREINO',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    
                ],
                columnsexer: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-videos",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdcancelacombinado(){
                let vself = this;
                if(vself.lstexercicioscombinados.length === 1){
                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].desccombo            = "";
                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].exercicioscombinados = [];
                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].combinado            = 0;
                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].descricao            = vself.lstexercicioscombinados[0].descricao;
                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].idexercicio          = vself.lstexercicioscombinados[0].idexercicio;
                }       
            },
            mtdincluirexerciciocombinado(){
                if(this.videxerciciocombinar === null){
                    this.$toastr.w('Selecione um exercicio para combinar', 'Atenção!');
                    $('#cbexerciciocombinar').select2('open');
                    return;
                }
                if(parseInt(this.videxerciciocombinar) === parseInt(this.lstitenstreinoalt[this.indicealteracaoexcombinado].idexercicio)){
                    this.$toastr.w('Os exercicio combinados não podem ser iguais', 'Atenção!');
                    $('#cbexerciciocombinar').select2('open');
                    return;
                }
                if(util.findValInArray(this.lstexercicioscombinados, 'idexercicio', this.videxerciciocombinar)){
                    this.$toastr.w('Exercicio já adicionado na listagem', 'Atenção!');
                    $('#cbexerciciocombinar').select2('open');
                    return;
                }
                let array = JSON.parse(JSON.stringify(this.lstexercicioscombinados));

                this.lstexercicioscombinados = [];
               
                let item = {
                    'idexercicio' : this.videxerciciocombinar,
                    'descricao'   : $('#cbexerciciocombinar').select2('data')[0]['text']
                };

                array.push(item);
                this.lstexercicioscombinados = JSON.parse(JSON.stringify(array));

                this.videxerciciocombinar =  null;
                $("#cbexerciciocombinar").val(null).trigger('change');

            },
            mtdconfirmaselecaocombinado(){
                let vself = this;
                if(vself.vdesccombo.trim() === ''){
                    this.$toastr.w('Informe o nome para o combo!', 'Atenção!');
                    return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a COMBINAÇÃO DE EXERCICIOS?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                if(vself.lstexercicioscombinados.length === 1){///se tiver apenas um ele vai virar o treino proncipal
                                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].desccombo            = "";
                                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].exercicioscombinados = [];
                                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].combinado            = 0;
                                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].descricao            = vself.lstexercicioscombinados[0].descricao;
                                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].idexercicio          = vself.lstexercicioscombinados[0].idexercicio;
                                }else{
                                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].desccombo            = vself.vdesccombo;
                                    vself.lstitenstreinoalt[vself.indicealteracaoexcombinado].exercicioscombinados = vself.lstexercicioscombinados;
                                }

                              
                                vself.lstexercicioscombinados = [];
                                vself.vdesccombo              = '';


                                $('#mdcombinarexercicios').modal('hide');
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdexcluircombinado(indice){
                this.lstexercicioscombinados.splice(indice, 1);
            },
            mtdselecionarexercicio(exercicio){
                this.vcoddigedicao = exercicio.id;
                this.mtdlocalizarexercicio(exercicio.id);
                $('#mdselecionarexercicio').modal('hide');
            },
            mtdfiltropesquisaexercicio(){
                let rfiltro = '';
                if (parseInt(this.pfiltroexercicio) === 0){
                    rfiltro = this.pconteudoexercicio === '' ? '' : ' and id='+this.pconteudoexercicio;
                }else{
                    rfiltro = this.pconteudoexercicio === '' ? '' : ' and upper(descricao) like upper("'+this.pconteudoexercicio+'%")';
                }
                return rfiltro;
            },
            mtdexecutapesquisaexercicios(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisaexercicio();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadexercicios.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registrosexer = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registrosexer / vself.pqtdregistrosexercicio);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaexercicios(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregaexercicios(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisaexercicio();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadexercicios.php');
                retorno.then(function (response) {
                    vself.lstexercicios = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstexercicios = [];
                    loader.hide();
                });
            },
            mtdverificaitens(){
                var ret = true;
                for (let index = 0; index < this.lsttreinos.length; index++) {// for dos treinos
                    var ibtns = []
                    ibtns = this.lsttreinos[index].exerciciostreino;
                   if(ibtns.length === 0){
                     ret = false
                   }
                }
                return ret;
            },
            confirmaitenstreino(){
                this.lsttreinos[this.indicealteracaoitens].exerciciostreino = this.lstitenstreinoalt;
                this.lstitenstreinoalt = [];
                $('#mdedicaoitenstreino').modal('hide');
            },
            mtdexcluiritembotao(indice){
                let vself  = this;
                let ind    = indice
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a EXCLUSAO DO EXERCICIO?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.lstitenstreinoalt.splice(ind, 1);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
                
            },
            mtdadicionarcombinados(indice){
               this.indicealteracaoexcombinado = indice; 
               this.lstexercicioscombinados    = JSON.parse(JSON.stringify(this.lstitenstreinoalt[indice].exercicioscombinados));

               if(parseInt(this.lstitenstreinoalt[indice].combinado) === 0){
                    let combinado = {
                        'idexercicio' : this.lstitenstreinoalt[indice].idexercicio,
                        'descricao'   : this.lstitenstreinoalt[indice].descricao
                    }
                    this.lstexercicioscombinados.push(combinado);
                    this.vlabelexercicios                       = this.lstitenstreinoalt[indice].descricao;
                    this.vdesccombo                             = this.lstitenstreinoalt[indice].desccombo;
                    this.lstitenstreinoalt[indice].combinado    = 1;
                    this.lstitenstreinoalt[indice].idexercicio  = 999999;
                    this.lstitenstreinoalt[indice].descricao    = "";
               }


               $('#mdcombinarexercicios').modal('show');
            },
            mtdincluirprodutobotao(){
                let vself = this;
                if(vself.videxercicioedicao === null){
                    vself.$toastr.w('Adicione o item na edição!', 'Atenção!');
                    return;
                }
                let itensbtn = [];
                if(parseInt(vself.vcombinado)===0){
                    itensbtn =  this.lstitenstreinoalt;
                    let item = {
                        'idtreino'               : vself.lsttreinos[vself.indicealteracaoitens].id,
                        'idexercicio'            : vself.videxercicioedicao,
                        'descricao'              : $('#cbexercicioincluir').select2('data')[0]['text'], 
                        'desccombo'              : "", 
                        'exercicioscombinados'   : [],//colocar a variavel correspondente
                        'combinado'              : vself.vcombinado,//colocar a variavel correspondente
                    };
                    itensbtn.push(item);

                    this.lstitenstreinoalt = [];

                    this.lstitenstreinoalt = itensbtn; 
                    
                    vself.videxercicioedicao = null;
                    $('#cbexercicioincluir').val(null).trigger('change');
                
                }else{
                    itensbtn        =  this.lstitenstreinoalt;

                    ///vself.vindicegeralcombo =  itensbtn.length + 1;
                    vself.vlabelexercicios  = $('#cbexercicioincluir').select2('data')[0]['text'];


                    let combinado = [
                        {
                            'idexercicio' : this.videxercicioedicao,
                            'descricao'   : $('#cbexercicioincluir').select2('data')[0]['text']
                        }
                    ]


                    let item = {
                        'idtreino'               : vself.lsttreinos[vself.indicealteracaoitens].id,
                        'idexercicio'            : 999999,
                        'descricao'              : "", 
                        'desccombo'              : "", 
                        'exercicioscombinados'   : combinado,//colocar a variavel correspondente
                        'combinado'              : vself.vcombinado,//colocar a variavel correspondente
                    };
                    itensbtn.push(item);

                    this.lstitenstreinoalt = [];

                    this.lstitenstreinoalt = itensbtn; 
                    
                    vself.videxercicioedicao = null;
                    $('#cbexercicioincluir').val(null).trigger('change');
       

                    setTimeout(() => {
                        vself.mtdadicionarcombinados(this.lstitenstreinoalt.length - 1);
                    }, 500);

                   
                }
            },
            mtdlocalizarexercicio(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ' and id ='+coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0}, 
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadexercicios.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let exercicio = response.data[0];							
							vself.videxercicioedicao	        = exercicio.id;
							vself.vdescricaoexercicioedicao 	= exercicio.descricao;
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
						
						}
					}).catch(function (response) {
						loader.hide();
					});
				}
            },
            mtdconsultarexercicio(){ 
                this.combinado              =  false;
                this.pqtdregistrosexercicio = 10;
                this.pconteudoexercicio     = '';
                this.pfiltroexercicio       = 0;
                this.mtdexecutapesquisaexercicios();
                $('#mdselecionarexercicio').modal('show');
			},
            mtdveritenstreino(index){
                this.lstitenstreinoalt         = this.lsttreinos[index].exerciciostreino;
                this.indicealteracaoitens      = index;
                this.vcoddigedicao             = '';
                this.videxercicioedicao        = 0; 
                this.vdescricaoexercicioedicao = '';    
                $('#mdedicaoitenstreino').modal('show');

            },
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},            
            mtddefinicoesiniciais(){
                let vself = this;

                $("#cbexerciciocombinar").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbexercicios',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.videxerciciocombinar  = $("#cbexerciciocombinar").val();
                }); 

                $("#cbexercicioincluir").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbexercicios',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.videxercicioedicao  = $("#cbexercicioincluir").val();
                }); 
                                           
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(descricao) like upper('+this.pconteudo+'%)';
                }
                if (parseInt(this.ptipo) < 2){
                    rfiltro = rfiltro + ' and tipo='+this.ptipo;
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadplanosdetreino.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregagrupocontas(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregagrupocontas(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadplanosdetreino.php');
                retorno.then(function (response) {
                    vself.lstplanosdetreino = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstplanosdetreino = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                 = '';
                this.vdescricao          = '';
                this.vtipo               = 0;
                this.lsttreinos          = [];

                this.vordem              = 0;
                this.vdescricaotreino    = '';
             
            },
            mtddefault(){
                $('#pnlista').hide();
                $('#pnimportacao').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('001Z.150Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PLANO DE TREINO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnimportacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstplanosdetreino = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }

                    if(!vself.mtdverificaitens()){
                        vself.$toastr.w('Há treinos sem itens, a adição item aos treinos é obrigatório!', 'Atenção!');
                        return
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadplanosdetreino.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('001Z.150Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE PLANOS DE TREINO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('001Z.150Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE PLANOS DE TREINO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vdescricao          = registro.descricao;

                this.lsttreinos           = registro.treinos;



                console.log('Registro:', registro);
                console.log('Lista de planos:', this.lsttreinos);

                if (this.lsttreinos && this.lsttreinos.length > 0) {
                    this.vordem = this.lsttreinos[this.lsttreinos.length - 1]['id'];
                }
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'treinos'           : this.lsttreinos
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.150Z.010Z' : parseInt(this.opcrud) === 2 ? '001Z.150Z.020Z' : '001Z.150Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadplanosdetreino.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregagrupocontas(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdincluirtreino(){
                let vself = this;
                if (vself.vdescricaotreino.trim() === ''){
                    vself.$toastr.w('Descrição do treino deve ser informada!', 'Atenção!');
                    $('#eddescricaotreino').focus();                
                    return;
                }
                if (vself.lsttreinos) {
                    if (vself.lsttreinos.length > 0) {
                        ++vself.vordem;
                    } else {
                        vself.vordem = 1;
                    }
                }else{
                    vself.lsttreinos = [];
                    vself.vordem    = 1;
                }
                let botao = {
                    'id'                    : vself.vordem,
                    'descricao'             : vself.vdescricaotreino.toUpperCase(),
                    'exerciciostreino'      : []
                };
                this.lsttreinos.push(botao);

                this.vdescricaotreino    = '';
               
                
                $('#eddescricaotreino').focus();                                
            },
            mtdexcluirtreino(indice){
                let vself  = this;
                let ind    = indice
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a EXCLUSAO DO TREINO?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.lsttreinos.splice(ind, 1);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdrotinaimportacao(){
                if (!util.opcaousuario('001Z.060Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'IMPORTAÇÃO DE CADASTROS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    $('#pnlista').hide();
                    this.resetarDados();
                    this.arqselecionado = null;
                    this.vlimpardados   = false;
                    this.vadicionaraocadastro = false;
                    this.vimportarcodigos   = false;
                    $('#pnimportacao').fadeIn(700);
                }                
            },
            mtdalterartreino(indice, descricao){
                this.indicebotaoedicao = indice;
                this.descbotaoedicao   = descricao;
              
                $('#mdledicaobotao').modal('show');
                setTimeout(() => {
                    $('#ededicaobotao').focus();
                }, 500);
            },
            mtdconfirmaedicaobotao(){
                if (this.descbotaoedicao === ''){
                    msgnotif("Descrição do treino deve ser informada!", 'Atenção', 'warning', 'toast-top-right');
                    $('#ededicaobotao').focus();
                    return;
                }
                this.lsttreinos[this.indicebotaoedicao].descricao    = this.descbotaoedicao.toUpperCase();
              
                $('#mdledicaobotao').modal('hide');
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                    
                    if (util.opcaousuario('001Z.150Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtddefinicoesiniciais();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.lsttreinos.length === 0;
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregagrupocontas(val);
            },
           
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-tipo{
        width: 60px !important;
    }    
</style>